import { EnvMicroProcurement } from "lib-klab-core";

export const envProcurementLocal: EnvMicroProcurement = {
    host: "",
    apiBasePath: "/ms-procurement",
    enabled: true,
    companyId: 1,
    useMocks: false
};

export const envProcurementDev: EnvMicroProcurement = {
    host: "https://gatewayapi-dev.erp.inclub.world",
    apiBasePath: "/ms-procurement",
    enabled: true,
    companyId: 1,
    useMocks: false
};

export const envProcurementProd: EnvMicroProcurement = {
    host: "",
    apiBasePath: "/ms-procurement",
    enabled: false,
    companyId: 1,
    useMocks: false
};
